import { Component, DestroyRef, inject, Inject, Input, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserProfile } from 'src/app/models/profile.model';
import { UpdateLocationDialogComponent } from '../update-location-dialog/update-location-dialog.component';
import { isPlatformServer } from '@angular/common';
import { Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'profile-location-field',
    templateUrl: './profile-location-field.component.html',
    styleUrl: './profile-location-field.component.scss',
    standalone: false
})
export class ProfileLocationFieldComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  @ViewChild('mapelement') mapelement;

  map: any;

  userProfile: UserProfile;
  @Input() userProfile$: Observable<UserProfile>;

  hasInitMap: boolean = false;
  locationChanged: boolean = false;
  loading: boolean = true;

  newLocation: string;
  currentLocation: { lat: number; long: number };
  currentRadius: number;

  constructor(
    private dialog: MatDialog,
    @Inject(PLATFORM_ID) protected _platformId: Object
  ) {}

  ngOnInit(): void {
    this.userProfile$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: UserProfile) => {
        if(!data) return;
        
        if(data.location) {
          this.loading = true;

          this.currentLocation = {
            long: + data.location.split(';')[0],
            lat: + data.location.split(';')[1],
          };
          
          this.currentRadius = + data.location.split(';')[3];

          if(!this.hasInitMap) {
            this.initMap();
          }
          this.userProfile = data;

          this.loading = false;
        }
      })
  }

  async initMap() {
    if (isPlatformServer(this._platformId)) {
      return;
    }

    const azureModule = await import('azure-maps-control');
    const azurecontrol = azureModule.default || azureModule;
    const serviceOptions = {
      authOptions: {
        authType: azurecontrol.AuthenticationType.subscriptionKey,
        subscriptionKey: 'SROjwQ2cy75Xj0GHK5hcjAoPMSAGa7s3ozx1C9mm0RQ'
      }
    };

    //atlas.Map
    this.map = (await import('azure-maps-control')).Map;

    this.map = new azurecontrol.Map(this.mapelement.nativeElement, {
      center: [this.currentLocation.long, this.currentLocation.lat],
      zoom: 15,
      language: 'nl-NL',
      options: serviceOptions,
    });

    this.map.markers.clear();
    //Create an HTML marker and add it to the map.
    var marker = new azurecontrol.HtmlMarker({
      position: [this.currentLocation.long, this.currentLocation.lat],
      htmlContent: this.getMarkerContent(),
    });

    this.map.markers.add(marker);

    this.map.setUserInteraction({ interactive: false });
  }

  onCustomLocationChanged(newLocation: string): void {
    this.newLocation = newLocation;
    this.locationChanged = true;
    this.resetMapToNewLocation(this.newLocation);
  }

  edit() {
    this.dialog.open<UpdateLocationDialogComponent>(
      UpdateLocationDialogComponent,
      {
        autoFocus: false, // To prevent select state of close button in header
        panelClass: 'medium',
        data: {
          userProfile: this.userProfile,
        },
      }
    );
  }

  getLocationInfo(): string {
    if (!!this.userProfile && !!this.userProfile.location) {
      return this.userProfile.location.split(';')[2];
    }

    return 'Nog geen locatie ingevuld.';
  }

  resetMapToNewLocation(location: string): void {
    if (!!location) {
      this.map.setCamera({
        center: [+location.split(';')[0], +location.split(';')[1]],
        type: 'fly',
      });
      this.map.markers
        .getMarkers()[0]
        .setOptions({
          position: [+location.split(';')[0], +location.split(';')[1]],
        });
    }
  }

  getMarkerContent(): string {
    return '<div class="marker"><div class="pin bounce"><div class="marker-title"><div class="filler"></div><div class="title">Ingestelde locatie<div></div></div></div>';
  }
}
